import { TranslationParams, TranslationToken, TranslationTokens } from './translate.util';

export class TokenBuilder {
  readonly #tokens: TranslationToken[] = [];

  get length(): number {
    return this.#tokens.length;
  }

  add(token: string, params?: TranslationParams): this;
  add(token: TranslationToken): this;
  add(token: TranslationToken, params?: TranslationParams): this {
    this.#tokens.push(typeof token === 'string' && params ? [token, params] : token);

    return this;
  }

  build(separator?: string): TranslationTokens {
    return separator ? this.#join(separator) : this.#tokens;
  }

  #join(separator: string): TranslationTokens {
    const tokens: TranslationToken[] = [];

    this.#tokens.forEach((item, index) => {
      if (index > 0) {
        // wrapped in RawString so `translate()` emits it verbatim instead of dispatching
        // `instant(separator)` — a guaranteed cache miss that a missing-translation handler would mangle
        tokens.push({ raw: separator });
      }

      tokens.push(item);
    });

    return tokens;
  }
}
